import { render, staticRenderFns } from "./stayExchange.vue?vue&type=template&id=3dd62f4c&scoped=true&"
import script from "./stayExchange.vue?vue&type=script&lang=js&"
export * from "./stayExchange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd62f4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dd62f4c')) {
      api.createRecord('3dd62f4c', component.options)
    } else {
      api.reload('3dd62f4c', component.options)
    }
    module.hot.accept("./stayExchange.vue?vue&type=template&id=3dd62f4c&scoped=true&", function () {
      api.rerender('3dd62f4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/afterSale/afterSale/comp/stayExchange.vue"
export default component.exports